// extracted by mini-css-extract-plugin
module.exports = {"root":"_1PlHX","appIcon":"_2K97U","heading":"_29VBg","message":"_3X2NU"};